import axios
    from "axios";
import API_URL from "../constant/api.config";
import axiosInstance from '../axiosHttp';
import { setAuthHeaders } from "../utils/common";

export const getSupplierMember = (member_id, page_type="") => async () => {
    const { headers } = setAuthHeaders();
    return axiosInstance.get(API_URL + '/supplier/member/' + member_id + page_type, { headers }).then((response) => {
      return response.data;
    }).catch((err) => {
      console.log("Error ========== ", err);
    });
}
export const updateSupplierCompanyAction =
  (
    member_id,
    formData,
    established_year,
    target_country,
    address1,
    pincode,
    certificateFile,
    companyLogo
  ) =>
    async () => {
      const { headers } = setAuthHeaders();
      // headers['Content-Type'] = 'multipart/form-data';
      headers['Content-Type'] = undefined;

       const payload = new FormData();

      payload.append("member_id", member_id ?? "");
      payload.append("salutation", formData.salutation ?? "");
      payload.append("first_name", formData.first_name ?? "");
      payload.append("last_name", formData.last_name ?? "");
      payload.append("designation", formData.designation ?? "");
      payload.append("phone", formData.phone ?? "");
      payload.append("mobile", formData.mobile ?? "");
      payload.append("company_name", formData.company_name ?? "");
      payload.append("website", formData.website ?? "");
      payload.append("trading_countries", (target_country || []).join(","));
      payload.append("est_year", established_year ?? "");
      payload.append("country", formData.country_id ?? "");
      payload.append("city", formData.cities_id ?? "");
      payload.append("address", address1 ?? "");
      payload.append("postal_code", pincode ?? "");
      payload.append("isNewVal", formData.isNewVal ?? false);

      if (certificateFile) {
        payload.append("business_certificate", certificateFile);
      }
      if (companyLogo) {
        payload.append("company_logo", companyLogo);
      }

      return await axiosInstance.post(API_URL + "/supplier/member/basic-info", payload, { headers })
        .then((response) => {
          if (response.data.status === true) {
            return true;
          }
          if (response.data.message === "Validation Errors") {
            return response.data;
          }
        })
        .catch((error) => {
          if (error?.response?.status === 422) {
            return error.response.data;
          }
          console.log(error);
        });
    };


  // export const postSupplierProduct =
  // (member_id, products) =>
  // async () => {
  //   const { headers } = setAuthHeaders();
  //   headers['Content-Type'] = 'multipart/form-data';

  //   const payload = new FormData();

  //   products.forEach((product, index) => {
  //     payload.append(`data[${index}][product_name]`, product.product_name ?? "");
  //     payload.append(`data[${index}][category_id]`, product.category?.value ?? "");
  //     payload.append(`data[${index}][hs_code_id]`, product.hs_code?.value ?? "");

  //     if (product.image) {
  //       payload.append(`data[${index}][product_photo]`, product.image);
  //     }
  //   });

  //   return await axios
  //     .post(API_URL + "/supplier/member/save-product-info/" + member_id, payload, { headers })
  //     .then((response) => {
  //       if (response.data.status === true) {
  //         return true;
  //       }
  //       return response.data;
  //     })
  //     .catch((error) => {
  //       if (error?.response?.status === 422) {
  //         return error.response.data;
  //       }
  //       console.log(error);
  //       return false;
  //     });
  // };

   export const assignSupplierTrailPlan =
  (member_id) =>
  async () => {
    const { headers } = setAuthHeaders();
    return await axiosInstance.post(API_URL + "/supplier/assign-plan/" + member_id, { headers })
      .then((response) => {
        if (response.data.status === true) {
          return true;
        }
        return response.data;
      })
      .catch((error) => {
        if (error?.response?.status === 422) {
          return error.response.data;
        }
        console.log(error);
        return false;
      });
  };

export const removeSupplierLogo = (id) => (dispatch) => {
 const { headers } = setAuthHeaders();
  return axiosInstance.delete(API_URL + '/supplier/logo-delete/' + id, { headers }).then((response) => {
    return response.data;
  }).catch((err) => {
    console.log("Error ========== ", err);
  });
};

export const postSupplierProduct =
  (member_id, products) =>
  async () => {
    const { headers } = setAuthHeaders();
    headers['Content-Type'] = undefined;
    const payload = new FormData();

    products.forEach((product, index) => {
      payload.append(`data[${index}][product_name]`, product.product_name ?? "");
      payload.append(`data[${index}][category_id]`, product.category?.value ?? "");
      payload.append(`data[${index}][hs_code_id]`, product.hs_code?.value ?? "");

      if (product.image) {
        payload.append(`data[${index}][product_photo]`, product.image);
      }
    });

    return await axiosInstance
      .post(API_URL + "/supplier/member/save-product-info/" + member_id, payload, { headers })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (error?.response?.status === 422) {
          return error.response.data;
        }
        console.log(error);
        return false;
      });
  };


  export const removeSupplierProduct = (id) => (dispatch) => {
  const { headers } = setAuthHeaders();
  return axiosInstance.delete(API_URL + '/supplier/member/product/' + id + '/stepper', { headers }).then((response) => {
    return response.data;
  }).catch((err) => {
    console.log("Error ========== ", err);
  });
};

  export const removeSupplierProductImage = (id) => (dispatch) => {
  const { headers } = setAuthHeaders();
  return axiosInstance.delete(API_URL + '/supplier/member/product-image/' + id, { headers }).then((response) => {
    return response.data;
  }).catch((err) => {
    console.log("Error ========== ", err);
  });
};



  


  

  

  

